<template>
  <!-- 成员细胞资产配置 -->
  <div class="assetAllocation">
    <el-table class="mg-t-20" :data="tableData.data" border style="width: 100%">
      <el-table-column fixed prop="name" label="成员" align="center">
      </el-table-column>
      <el-table-column label="胎盘间质干细胞" align="center"> </el-table-column>
      <el-table-column label="胎盘造血干细胞" align="center"> </el-table-column>
      <el-table-column label="成人免疫细胞" align="center">
        <template slot-scope="scope">
          <i class="el-icon-circle-check"></i>
        </template>
      </el-table-column>
      <el-table-column label="新生儿免疫细胞" align="center">
        <template slot-scope="scope">
          <i class="el-icon-circle-check"></i>
        </template>
      </el-table-column>
      <el-table-column label="成人免疫细胞" align="center">
        <template slot-scope="scope">
          <i class="el-icon-circle-check"></i>
        </template>
      </el-table-column>
      <el-table-column label="胎盘造血干细胞" align="center">
        <template slot-scope="scope">
          <i class="el-icon-circle-check"></i>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :total="tableData.total"
      :per_page="tableData.per_page"
      :current_page="tableData.current_page"
      @handleCurrentChange="handleCurrentChange"
      @handleSizeChange="handleSizeChange"
    />
  </div>
</template>
<script>
import pagination from "../../../components/pagination.vue";

export default {
  name: "assetAllocation",
  data() {
    return {
      customerGroupForm: {
        search_keyword: "",
        search_start_time: "",
        search_end_time: "",
      },
      tableData: {
        data: [],
        per_page: 10,
        current_page: 1,
        total: 0,
      },
    };
  },
  components: {
    pagination,
  },
  props: ["uuid"],
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.axios({
        method: "get", //请求方法
        headers: {
          "Content-Type": "text/html;charset=UTF-8",
          "X-Access-Token": this.storage.get("__token"),
          Authorization: `Bearer ${this.storage.get("__token")}`,
        },
        url: ` https://time.api.boyalife.cn/v1/cms/UserGroup?page_size=${this.tableData.per_page}&page_index=${this.tableData.current_page}&search_keyword=${this.customerGroupForm.search_keyword}&search_start_time=${this.customerGroupForm.search_start_time}&search_end_time=${this.customerGroupForm.search_end_time}`,
      })
        .then((res) => {
          this.tableData = res.data.result;
        })
        .catch((err) => {
          this.$message.error(err.response.data.error.message);
        });
    },
    handleSizeChange(v) {
      this.tableData.per_page = v;
      this.getList();
    },
    handleCurrentChange(v) {
      this.tableData.current_page = v;
      this.getList();
    },
  },
};
</script>
<style scoped>
.el-icon-circle-check {
  color: #67c23a;
}
</style>
